module.exports = __webpack_public_path__ + "img/ImagineerTypesQuiz_Q9-lockup.20048058.png";